// Availability scale shared by native dots and detail pins.
export const COLORS = {red: '#fa5757', yellow: '#f5cf42', green: '#21c779', out: '#535b65', neutral: '#b5bdc7'};
export function availability(site, filters) {
  let available = site?.available || 0, known = site?.known ?? (site?.available === null ? 0 : site?.total || 0);
  let total = site?.total || 0, out = site?.out_of_service ?? (site?.status === 'out_of_service' ? total : 0);
  if (site?.points && (filters.plugs.size || filters.min || filters.max !== undefined || filters.onlyFree !== undefined || filters.hideOut !== undefined)) {
    const pts = site.points.filter(p => (!filters.plugs.size || p.connectors.some(s => filters.plugs.has(s)))
      && (p.kw || 0) >= filters.min && (p.kw || 0) <= (filters.max ?? Infinity)
      && (!filters.onlyFree || p.status !== 'unknown') && (!filters.hideOut || p.status !== 'out_of_service')
      // Price filter: ct is the cheapest ad-hoc kWh price of the point from prices.bin (0 = not reported).
      && (!(filters.maxPrice < Infinity) || (p.ct > 0 && p.ct <= filters.maxPrice)));
    total = pts.length;
    known = pts.filter(p => p.status !== 'unknown').length;
    available = pts.filter(p => p.status === 'free').length;
    out = pts.filter(p => p.status === 'out_of_service').length;
  }
  return {available, known, total, out, available_share: known ? available / known : 0};
}
const gradient = value => ['interpolate', ['linear'], value, 0, COLORS.red, 0.5, COLORS.yellow, 1, COLORS.green];
export const POINT_COLOR = ['case', ['all', ['>', ['get', 'total'], 0], ['==', ['get', 'out'], ['get', 'total']]], COLORS.out,
  ['>', ['get', 'known'], 0], gradient(['get', 'available_share']), COLORS.neutral];

export function circleText(c) { return c.total && c.out === c.total ? '✕' : !c.known ? '?' : `${c.available}/${c.total}`; }
